import React, { useState, useEffect } from 'react';
import AdminTemplate from 'components/templates/AdminTemplate';
import { Grid, Typography } from '@material-ui/core';
import ModalContainer from 'components/molecules/ModalContainer';
import useProvidersIM from 'hooks/useProvidersIM';
import IMProvidersList from 'components/organisms/IMProvidersList';
import IMProviderForm from 'components/organisms/IMProviderForm';
import { iProviders } from 'interfaces/imProviders.interface';

export default function IMProviders() {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [providerId, setProviderId] = useState('');
  const [providers, setProviders] = useState<iProviders[]>([]);
  const { getProvidersAll, addProvider, updateProvider } = useProvidersIM();

  const handleOnCloseModal = () => {
    setOpenModalEdit(false);
  };

  const getAllProviders = () => {
    setIsLoading(true);
    getProvidersAll()
      .then((result: iProviders[]) => {
        if (result) {
          setProviders(result);
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const saveProvider = (data: any) => {
    if (data.id) {
      return updateProvider(data);
    } else {
      return addProvider(data);
    }
  };

  const handleOnClickEditProvider = (warehouseId: string) => {
    setProviderId(warehouseId);
    setOpenModalEdit(true);
  };

  const addProviderButton = () => {
    setProviderId('');
    setOpenModalEdit(true);
  };

  useEffect(() => {
    getAllProviders();
  }, []);

  return (
    <AdminTemplate>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} sm={12}>
          <Typography variant="h5" component="h1" align="center">
            Gestión de Proveedores
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <IMProvidersList
            handleOnClickEditProvider={handleOnClickEditProvider}
            addProviderButton={addProviderButton}
            providers={providers}
            isLoading={isLoading}
          />
        </Grid>

        <ModalContainer title="Crear proveedor" open={openModalEdit} onClose={handleOnCloseModal}>
          <IMProviderForm
            handleCloseModal={handleOnCloseModal}
            handleOnSubmit={saveProvider}
            providerId={providerId}
            getAllProviders={getAllProviders}
          />
        </ModalContainer>
      </Grid>
    </AdminTemplate>
  );
}
